import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PartyDialog } from "@/components/admin/pratica";
import { Decision, Parties } from "@/pages/admin/AdminAmministrazioneDetail";
import { SUB_LABELS } from "@/components/admin/labels";

export const CantiereSub = ({ oid }) => {
  const [p, setP] = useState(null);
  const [party, setParty] = useState(false);
  const [editing, setEditing] = useState(null);
  useEffect(() => { api.get(`/amministrazione/${oid}`).then((r) => setP(r.data)).catch(() => {}); }, [oid]);
  if (!p) return null;
  const patch = async (body) => { try { setP((await api.patch(`/amministrazione/${oid}`, body)).data); } catch (e) { toast.error(errMsg(e)); } };
  const add = async (body) => { try { setP((await api.post(`/amministrazione/${oid}/parties`, body)).data); setParty(false); } catch (e) { toast.error(errMsg(e)); } };
  const edit = async (body) => { try { setP((await api.patch(`/amministrazione/${oid}/parties/${editing.id}`, body)).data); setEditing(null); } catch (e) { toast.error(errMsg(e)); } };
  const view = { ...p, parties: p.parties.map((x) => (x.kind === "subappalto" ? { ...x, items: x.items.map((it) => ({ ...it, label: SUB_LABELS[it.key] || it.label })) } : x)) };
  return (
    <div className="space-y-6" data-testid="cantiere-subappalti">
      <Decision p={p} patch={patch} />
      {p.subcontract_needed !== false && <Parties p={view} kind="subappalto" oid={oid} setP={setP} onAdd={() => setParty(true)} onEdit={setEditing} />}
      <PartyDialog open={party} kind="subappalto" onClose={() => setParty(false)} onSave={add} />
      <PartyDialog open={!!editing} kind="subappalto" initial={editing} onClose={() => setEditing(null)} onSave={edit} />
    </div>
  );
};
